import React, { useState } from "react";
import { Button, ButtonGroup, Card, Stack } from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import { ProseMirrorWrapper } from "./ProseMirrorWrapper";
import { CraComment } from "../../models/CraComment";
import { useStores } from "../../../shared/stores/RootStore";
import { toast } from "../../../shared/views/CustomToaster";

interface Props {
  craWayId: string;
  mainThread?: CraComment;
  nodeId?: string;
  onClose?: () => void;
}
const CommentCreatorBase: React.FC<Props> = ({
  mainThread,
  nodeId,
  craWayId,
  onClose,
}) => {
  const { craCommentStore } = useStores();
  const [markdown, setMarkdown] = useState("");

  const submitComment = () => {
    if (markdown) {
      craCommentStore.postComment({
        craWayId: mainThread?.craWayId ?? craWayId,
        craNodeId: nodeId ?? null,
        content: markdown,
        mainThreadId: mainThread?.id ?? null,
      });
      onClose?.();
    } else {
      toast("error", t(`map:comments.emptySubmit`));
    }
  };

  return (
    <Stack gap={2}>
      <Card.Root variant="outline">
        <ProseMirrorWrapper defaultContent={""} onChange={setMarkdown} />
      </Card.Root>
      <ButtonGroup
        size="sm"
        alignSelf="end"
        colorPalette="primary"
        fontSize="sm"
      >
        {!!onClose && (
          <Button variant="ghost" onClick={onClose}>
            {t(`map:comments.cancel`)}
          </Button>
        )}
        <Button onClick={submitComment}>
          {mainThread ? t(`map:comments.reply`) : t(`map:comments.submit`)}
        </Button>
      </ButtonGroup>
    </Stack>
  );
};

export const CommentCreator = observer(CommentCreatorBase);
